import React, { useState } from 'react';
import Link from 'next/link';
import AllianceModal from '@components/common/modals/affiliateModal/affiliateList';
import { RouteUrl } from '@utils/routeUtil';

import classNames from 'classnames/bind';
import styles from './deepResultSample.module.scss';
const cx = classNames.bind(styles);

const DeepResultSample = () => {
  const [allianceModalVisible, setAllianceModalVisible] = useState(false);

  return (
    <>
      <div className={cx('resultSampleArea')}>
        <div className={cx('layer')}>
          <strong className={cx('title')}>
            제휴서비스를 입력하면
            <br />
            역량 분석결과를 볼 수 있어요.
          </strong>

          <div className={cx('btnArea')}>
            <Link href={RouteUrl.MY_PAGE_PREMIUM} legacyBehavior>
              <a className={cx('btn', 'type1')} target="_blank" role="button">
                제휴서비스 신청하기
              </a>
            </Link>
            <a className={cx('btn', 'type2')} role="button" onClick={() => setAllianceModalVisible(true)}>
              제휴 리스트 확인하기
            </a>
          </div>
        </div>
      </div>

      <AllianceModal visible={allianceModalVisible} onClose={() => setAllianceModalVisible(false)} />
    </>
  );
};

export default DeepResultSample;
